<template>
    <div class="col-md-12 mx-auto">
        <div>
            <action-register :showPinButton="true" :all="all"></action-register>
        </div>
        <div>
            <audit-register :showPinButton="true" :all="all"></audit-register>
        </div>
    </div>
</template>

<script>
    import ActionRegister from "../../components/administration/audit/ActionRegister";
    import AuditRegister from "../../components/administration/audit/AuditRegister";

    export default {
        props: {
            all: {
                type: Boolean,
                default: false
            },
        },
        components: {
            AuditRegister,
            ActionRegister
        },
        data() {
            return {

            };
        },
        methods: {

        },
        mounted: function () {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>
